// 所有工具组件的中文文案（按 componentType 驼峰组织）
// 命名: tool.<key>.*  通用词统一走 common.* 避免重复
export default {
  // ----- 编码解码 -----
  UrlCodec: {
    title: 'URL 编解码',
    componentMode: '组件编码', componentTip: 'encodeURI — 保留 / ? = & # 等 URL 结构字符，只编码中文和空格',
    fullMode: '完整编码', fullTip: 'encodeURIComponent — 所有非字母数字字符均转为 %XX',
    phInput: '输入文本或编码后的字符串…', phPasted: '粘贴要编码或解码的内容…',
    hintEmpty: '输入文本，点击编码或解码进行转换', detectEncoded: '检测到编码内容，建议点解码',
    detectPlain: '未编码文本，建议点编码', msgEncoded: '编码完成 · {n} 字符',
    msgEncodeFail: '编码失败: {msg}', msgDecoded: '解码完成 · {n} 字符',
    msgDecodeFail: '解码失败，请检查输入是否为有效的 URL 编码格式',
    sample: 'https://example.com/搜索?q=你好 世界&lang=zh'
  },
  UnicodeCodec: {
    title: 'Unicode 编解码', phInput: '输入文本或 Unicode 转义序列…',
    phPasted: '粘贴要编码或解码的内容…', hintEmpty: '输入文本，点击编码或解码进行转换',
    detectEncoded: '检测到 Unicode 转义序列，建议点解码', detectPlain: '未编码文本，建议点编码',
    msgEncoded: '编码完成 · {n} 字符', msgEncodeFail: '编码失败: {msg}',
    msgDecoded: '解码完成 · {n} 字符', msgDecodeFail: '解码失败，请检查输入格式',
    sample: '你好，世界！\\u4f60\\u597d\\uff0c\\u4e16\\u754c\\uff01 Hello World \\uD83C\\uDF0D'
  },
  Base64Codec: {
    title: 'Base64 编解码', urlSafe: 'URL 安全模式',
    urlSafeTip: '将 + 替换为 -，/ 替换为 _，去掉末尾 =', phInput: '输入文本或 Base64 字符串…',
    phPasted: '粘贴要编码或解码的内容…', hintEmpty: '输入文本，点击编码或解码进行转换',
    detectBase64: '检测到 Base64 格式，建议点解码', detectPlain: '未编码文本，建议点编码',
    msgEncoded: '编码完成 · {n} 字符', msgEncodeFail: '编码失败: {msg}',
    msgDecoded: '解码完成 · {n} 字符', msgDecodeFail: '解码失败，无效的 Base64 格式',
    sample: '你好，世界！Hello World 🌍'
  },
  // ----- 文本处理 -----
  JsonEditor: {
    title: 'JSON 格式化', phInput: '粘贴 JSON 文本...',
    hintEmpty: '粘贴 JSON 文本，点击格式化', valid: 'JSON 有效',
    validatePass: 'JSON 校验通过', noContent: '无内容可复制', copyFailed: '复制失败'
  },
  SqlFormatter: {
    title: 'SQL 格式化', phInput: '粘贴 SQL 语句...',
    hintEmpty: '粘贴 SQL 语句，点击格式化'
  },
  CodeEditor: {
    title: '代码格式化',
    phJs: '粘贴 JavaScript 代码...', phHtml: '粘贴 HTML 代码...',
    phCss: '粘贴 CSS 代码...', phSql: '粘贴 SQL 语句...', phJava: '粘贴 Java 代码...',
    phC: '粘贴 C 代码...', phCpp: '粘贴 C++ 代码...', phPython: '粘贴 Python 代码...', phGo: '粘贴 Go 代码...'
  },
  Generator: {
    title: '随机字符串生成', desc: '设置参数生成随机字符串',
    lenLabel: '长度', lenHint: '4-512 位', countLabel: '数量（{n} 个）',
    charsetLabel: '字符集', charsetAlphanum: '字母 + 数字', charsetAll: '字母 + 数字 + 符号',
    charsetUpper: '仅大写字母', charsetLower: '仅小写字母', charsetDigits: '仅数字',
    charsetHex: '十六进制 (0-9 A-F)', btnGenerate: '生成',
    resultLabel: '结果（{n} 个）', copyAll: '复制全部', copy: '复制',
    empty: '点击生成按钮', copiedAll: '已复制全部'
  },
  DiffViewer: {
    subtitle: '文本差异对比 · 逐行逐字高亮', paneA: '原文本', phA: '请输入原文本...',
    paneB: '新文本', phB: '请输入新文本...', same: '{n} 行相同', removed: '{n} 行删除',
    added: '{n} 行新增', modified: '{n} 行修改', copyDiff: '复制差异',
    empty: '输入文本后自动对比差异', copiedDiff: '已复制差异'
  },
  // ----- 计算 / 转换 -----
  Calculator: {
    title: '简易计算器', copyResult: '复制结果', hint: '支持 + − × ÷ % √ ^ |x| () · 回车计算',
    invalidResult: '计算结果无效', exprError: '表达式错误', noResult: '无结果'
  },
  Converter: {
    selectType: '选择转换类型', typeBase64Encode: 'Base64 编码', typeBase64Decode: 'Base64 解码',
    typeUrlEncode: 'URL 编码', typeUrlDecode: 'URL 解码', typeUnicodeDecode: 'Unicode 转中文',
    typeUnicodeEncode: '中文转 Unicode', typeCaseToggle: '大小写转换',
    input: '输入', phInput: '请输入内容...', output: '输出', convertFail: '转换失败: {msg}'
  },
  // ----- 图形 / 颜色 -----
  ColorPicker: { pickColor: '请选择颜色', copy: '复制' },
  QrcodeGenerator: { phInput: '输入文本或URL...', download: '下载' },
  // ----- 文档转换 -----
  WordToHtml: {
    upload: '上传 Word', uploadHint: '.docx / .doc · Max 50MB',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnConvert: '开始转换', resultLabel: '转换结果', resultHint: 'HTML 预览',
    download: '下载 HTML', reupload: '重新上传', maxSize: '最大50M', convertFail: '转换失败'
  },
  HtmlToWord: {
    title: 'HTML 转 Word', preview: '预览', download: '下载 Word',
    phHtml: '粘贴 HTML 代码…', previewTitle: '预览',
    hintChars: '{n} 字符', hintPreviewMode: ' · 预览模式', hintEmpty: '粘贴 HTML 代码，点击下载 Word 文档',
    downloading: '下载中...', emptyDoc: '空文档',
    sampleDocTitle: '文档标题', sampleBold: '加粗', sampleItalic: '斜体',
    sampleName: '姓名', sampleAge: '年龄', sampleNameVal: '张三', sampleAgeVal: '28'
  },
  // ----- 图片处理 -----
  ImageBgRemove: {
    title: '证件照换背景', upload: '上传证件照', uploadHint: 'PNG / JPEG · 最大 20M',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnRed: '红底', btnWhite: '白底', btnBlue: '蓝底',
    customColor: '自定义', precision: '精度', download: '下载 PNG',
    reupload: '重新上传', maxSize: '最大20M', noFile: '请先上传图片',
    processing: '处理中...', done: '处理完成'
  },
  ImageCompress: {
    title: '图片压缩', upload: '上传图片', uploadHint: 'PNG / JPEG / WebP · 最大 20M',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    quality: '压缩质量', original: '原图', compressed: '压缩后',
    btnCompress: '开始压缩', download: '下载', reupload: '重新上传',
    maxSize: '最大20M', noFile: '请先上传图片'
  },
  ImageOcr: {
    title: '图片文字识别', upload: '上传图片', uploadHint: 'PNG / JPEG / WebP',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnStart: '开始识别', resultLabel: '识别结果', copy: '复制',
    reupload: '重新上传', processing: '识别中...', noFile: '请先上传图片',
    noText: '未识别到文字', maxSize: '文件大小不能超过50MB'
  },
  QrDecoder: {
    title: '二维码解码', upload: '上传二维码', uploadHint: 'PNG / JPEG',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnDecode: '识别', resultLabel: '解码内容', reupload: '重新上传',
    processing: '解码中...', noFile: '请先上传图片', noResult: '未识别到二维码'
  },
  ColorExtractor: {
    title: '颜色提取', upload: '上传图片', uploadHint: 'PNG / JPEG · 点击图片提取颜色',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    resultLabel: '选取颜色', reupload: '重新上传', noFile: '请先上传图片'
  },
  IconGenerator: {
    title: '图标生成', shape: '形状', shapeRounded: '圆角方形', shapeCircle: '圆形', shapeSquare: '方形', shapeDiamond: '菱形',
    bgColor: '背景色', text: '文字', fontSize: '字号', radius: '圆角',
    download16: '16px', download32: '32px', download64: '64px', download128: '128px', download256: '256px'
  },
  // ----- 开发工具 -----
  CryptoTool: {
    title: '加解密工具', modeAES: 'AES', modeHash: '哈希', modeHMAC: 'HMAC', modeRSA: 'RSA', modeEncode: '编码转换',
    aesMode: '模式', aesCBC: 'CBC', aesGCM: 'GCM', aesKey: '密钥', aesKey128: '128位', aesKey256: '256位',
    aesIv: '偏移量(IV)', aesInput: '输入', aesOutput: '输出', aesEncrypt: '加密', aesDecrypt: '解密',
    hashAlgo: '算法', hashInput: '输入', hashOutput: '输出',
    rsaGenerate: '生成密钥对', rsaPubKey: '公钥', rsaPrivKey: '私钥', rsaEncrypt: '公钥加密', rsaDecrypt: '私钥解密',
    encType: '类型', encInput: '输入', encOutput: '输出',
    plaintext: '明文', ciphertext: '密文', ciphertextBase64: '密文 (Base64)',
    raw: '原始', text: '文本', encoded: '编码后',
    genKey: '生成密钥', randomKey: '随机密钥', computeHash: '计算哈希', upper: '大写', computeHmac: '计算 HMAC',
    phKey: '密钥', phPlaintext: '输入明文...', phCiphertext: '加密后显示...',
    phMsg: '输入消息内容...', phInput: '输入...', phResult: '结果...',
    phHexBits: '{n} 位十六进制', genRsaKey: '生成 2048 位密钥对', ready: '就绪',
    errEncrypt: '加密失败', errDecrypt: '解密失败', errGen: '生成失败', errNeedKey: '请先生成密钥对'
  },
  TimestampTool: {
    title: '时间戳转换', current: '当前时间戳', tsToDate: '时间戳 → 日期', dateToTs: '日期 → 时间戳',
    tsPlaceholder: '输入时间戳（秒或毫秒）', datePlaceholder: '选择日期时间',
    result: '转换结果', copy: '复制', now: '当前时间',
    unixSeconds: '当前 Unix 秒', unixMillis: 'Unix 毫秒', localTime: '本地时间',
    input: '输入', output: '输出',
    tsInputHint: '输入 10 位或 13 位数字', dateInputHint: '输入日期时间字符串',
    nowBtn: '此刻', tryTs: '试试粘贴时间戳：', tryDate: '试试粘贴日期：',
    commonRefs: '常用时间戳参考', todayRef: '今天 00:00',
    currentTimeRef: '当前时间', year2038Ref: '2038 临界点',
    weekDays: ['日','一','二','三','四','五','六'], weekPrefix: '星期',
    phTs: '例如 1717084800', phDate: '例如 2026-05-30 12:00',
    errDigits: '请输入纯数字时间戳', errLength: '请输入 10 位（秒）或 13 位（毫秒）时间戳',
    errInvalidTs: '无效的时间戳', errUnrecognized: '无法识别的日期格式，试试 2026-05-30 或 2026-05-30 12:00:00',
    resultLocalTime: '本地时间', resultUtcTime: 'UTC 时间', resultIso8601: 'ISO 8601',
    resultUnixSec: 'Unix 秒（10位）', resultUnixMs: 'Unix 毫秒（13位）', resultDateLocal: '对应本地时间'
  },
  JwtDecoder: {
    title: 'JWT 编解码', modeDecode: '解码', modeEncode: '编码',
    headerLabel: 'Header', payloadLabel: 'Payload', signatureLabel: '签名',
    jwtInput: '粘贴 JWT Token (xxxxx.yyyyy.zzzzz)…', secretLabel: '密钥（可选，用于验证签名）',
    algoLabel: '签名算法', algoHS256: 'HS256', algoHS384: 'HS384', algoHS512: 'HS512', algoNone: 'none',
    statusExpired: '已过期', statusValid: '有效', verifyOk: '✓ 签名有效', verifyFail: '✗ 签名无效',
    claimsIss: '签发者', claimsSub: '主题', claimsAud: '受众', claimsIat: '签发时间', claimsExp: '过期时间',
    claimsNbf: '生效时间', claimsJti: 'JWT ID',
    sigHint: '（签名用于防篡改，Header/Payload 只是 Base64 编码非加密，所以解码不需要密钥）',
    phVerifySecret: '输入密钥验证签名（HS256）', phEncSecret: '签名密钥（可选，留空则不签名）',
    verify: '验证签名', generate: '生成 JWT', generatedJwt: '生成的 JWT',
    decodeOk: '解析成功', decodeHint: '粘贴 JWT Token 自动解析',
    errFormat: '无效 JWT 格式，应为 header.payload.signature', errParse: '解析失败', errEncode: '编码失败',
    jsonHint: '（JSON）'
  },
  YamlJson: {
    title: 'YAML / JSON 转换', inputLabel: 'YAML', outputLabel: 'JSON',
    phInput: '输入 YAML 或 JSON，点击对应按钮转换...', phOutput: '粘贴 JSON...',
    yamlToJson: 'YAML → JSON', jsonToYaml: 'JSON → YAML',
    hint: '粘贴 YAML 或 JSON，点击按钮双向转换',
    errYaml: 'YAML 解析失败', errJson: 'JSON 格式错误'
  },
  BaseConverter: {
    title: '进制转换', dec: '十进制', hex: '十六进制', bin: '二进制', oct: '八进制',
    hint: '在任意栏输入数值，其余自动转换',
    phDec: '如 255', phHex: '如 FF', phBin: '如 11111111', phOct: '如 377',
    errInvalid: '无效的{radix}进制数值', errConvert: '转换失败'
  },
  UuidGenerator: {
    title: 'UUID 生成', version: '版本', count: '数量', upper: '大写',
    btnGenerate: '生成', copyAll: '全部复制', copy: '复制', copiedAll: '已复制全部',
    emptyHint: '点击「生成」创建 UUID'
  },
  CaseConverter: {
    title: '大小写转换', input: '输入文本', output: '输出',
    copySelected: '复制选中', copied: '已复制',
    phInput: '输入文本，下方实时展示 8 种命名风格转换结果...',
    hintEmpty: '输入文本后自动转换为 8 种命名风格 · 点击卡片复制',
    types: { upper: '大写', lower: '小写', title: '首字母大写', camel: '驼峰',
      pascal: '帕斯卡', snake: '蛇形', kebab: '短横', constant: '常量' }
  },
  TextDedup: {
    title: '文本去重排序', input: '输入', output: '输出', btnDedup: '去重', btnSort: '排序',
    btnSortAsc: '升序', btnSortDesc: '降序', btnReverse: '反转', btnTrim: '去空行',
    phInput: '每行一个条目，粘贴文本后点击上方按钮处理...', phOutput: '处理结果...',
    hintEmpty: '每行一个条目，支持去重、排序、反转、去除空行',
    hintLines: '{lines} 行 · {chars} 字符',
    msgDedup: '去重：{before} → {after} 行（移除 {removed} 行）',
    msgSortAsc: '升序排列 {n} 行', msgSortDesc: '降序排列 {n} 行',
    msgReverse: '反转 {n} 行', msgTrim: '去空行：{before} → {after} 行（移除 {removed} 行）'
  },
  PasswordStrength: {
    title: '密码强度检测', generate: '生成强密码', strength: '强度',
    levels: { 0: '无', 1: '弱', 2: '一般', 3: '强', 4: '非常强' },
    criteria: { length: '长度 ≥ 8', length12: '长度 ≥ 12', upper: '大写字母', lower: '小写字母', digit: '数字', symbol: '特殊符号' },
    phPassword: '输入密码…', showPassword: '显示', hidePassword: '隐藏',
    hintEmpty: '输入密码，实时检测强度'
  },
  XmlFormatter: { title: 'XML 格式化', phInput: '粘贴 XML...', btnFormat: '格式化', btnToJson: '→ JSON' },
  HttpStatus: {
    title: 'HTTP 状态码', search: '搜索状态码...', category: '分类', code: '状态码', description: '说明',
    categories: { info: '信息响应', success: '成功', redirect: '重定向', clientError: '客户端错误', serverError: '服务端错误' }
  },
  HtmlEntity: {
    title: 'HTML 实体编解码', input: '输入', output: '输出',
    btnEncode: '编码', btnDecode: '解码', phInput: '输入文本或HTML代码...', phOutput: '实体结果...',
    hint: '输入文本，点击编码/解码/格式化/压缩',
    encoded: '编码完成', decoded: '解码完成',
    formatted: '格式化完成', compressed: '压缩完成',
    chars: '字符'
  },
  UnitConverter: {
    title: '单位换算', typeLabel: '类型', valueLabel: '数值',
    fromLabel: '从', toLabel: '到', resultLabel: '结果',
    phValue: '输入数值', swapTitle: '交换单位',
    hint: '选择类型，输入数值，自动换算',
    types: { storage: '存储', length: '长度', weight: '重量', temp: '温度', time: '时间' },
    units: {
      storage: { B:'B (字节)', KB:'KB', MB:'MB', GB:'GB', TB:'TB' },
      length: { mm:'毫米 mm', cm:'厘米 cm', m:'米 m', km:'千米 km', in:'英寸 in', ft:'英尺 ft', mi:'英里 mi' },
      weight: { mg:'毫克 mg', g:'克 g', kg:'千克 kg', t:'吨 t', oz:'盎司 oz', lb:'磅 lb' },
      temp: { c:'摄氏度 °C', f:'华氏度 °F', k:'开尔文 K' },
      time: { ms:'毫秒 ms', s:'秒 s', min:'分钟 min', h:'小时 h', d:'天 d', w:'周 w' }
    }
  },
  YamlProperties: {
    title: 'YAML / Properties 转换', inputLabel: 'YAML', outputLabel: 'Properties',
    phInput: '输入 YAML 或 Properties，点击对应按钮转换...', phOutput: '粘贴 Properties...',
    yamlToProp: 'YAML → Properties', propToYaml: 'Properties → YAML',
    hint: '粘贴 YAML 或 Properties，点击按钮双向转换',
    errYaml: 'YAML 解析失败', errProp: 'Properties 格式错误'
  },
  ApiTester: {
    title: 'HTTP 接口调试', method: '方法', url: 'URL', headers: 'Headers',
    body: 'Body', send: '发送', response: '响应', status: '状态码', time: '耗时',
    phUrl: 'https://api.example.com/endpoint', phKey: 'Key', phValue: 'Value',
    history: '历史记录', noResponse: '点击发送发起请求',
    addHeader: '添加', copyBody: '复制响应体', copyAll: '复制全部', errRequest: '请求失败',
    directMode: '直连模式', agentMode: 'Agent 模式',
    sessionId: '会话ID', phSessionId: '输入 Agent 显示的会话ID',
    downloadAgent: '下载 Agent', agentHelp: '接口地址在内网无法访问？下载 Agent 即可代理请求',
    errAgentConnect: '无法连接 Agent，请确认会话ID正确且 Agent 已启动'
  },
  SqlQuery: {
    title: 'SQL 在线查询', host: '主机', port: '端口', user: '用户名', password: '密码', database: '数据库',
    btnConnect: '连接', btnDisconnect: '断开', reconnect: '重新连接', tables: '表列表',
    editor: 'SQL 编辑器', btnRun: '运行 (Ctrl+Enter)', result: '查询结果', connected: '已连接',
    tableCount: '个表', copyResult: '复制结果', readonlyHint: '仅允许 SELECT / SHOW / DESCRIBE / EXPLAIN',
    hintLimit: '无 LIMIT 时默认返回 10 行', timeout: '查询超时',
    errConnect: '连接失败', errQuery: '查询失败',
    directMode: '直连模式', agentMode: 'Agent 模式',
    sessionId: '会话ID', phSessionId: '输入 Agent 显示的会话ID',
    downloadAgent: '下载 Agent', agentHelp: '无法连接内网数据库？下载 Agent 即可桥接访问',
    errAgentConnect: '无法连接 Agent，请确认会话ID正确且 Agent 已启动',
    agentDisconnected: 'Agent 已断开连接', reconnecting: '连接断开，正在重连...', reconnectFailed: '重连失败，请检查 Agent 是否运行',
    exportFormat: '格式', exportBtn: '导出', exportHint: '最多10万行', exportSuccess: '导出成功', errExport: '导出失败'
  },
  RedisQuery: {
    title: 'Redis 在线查询', host: '主机', port: '端口', password: '密码（可选）', db: 'DB',
    btnConnect: '连接', btnDisconnect: '断开', connected: '已连接', command: '命令', btnRun: '执行',
    result: '结果', hintReadonly: '仅允许只读命令', hintCommands: '支持: GET / MGET / HGET / HGETALL...',
    timeout: '查询超时', errConnect: '连接失败', errQuery: '查询失败',
    directMode: '直连模式', agentMode: 'Agent 模式', reconnect: '重新连接',
    sessionId: '会话ID', phSessionId: '输入 Agent 显示的会话ID',
    downloadAgent: '下载 Agent', agentHelp: '无法连接内网 Redis？下载 Agent 即可桥接访问',
    errAgentConnect: '无法连接 Agent，请确认会话ID正确且 Agent 已启动',
    agentDisconnected: 'Agent 已断开连接', reconnecting: '连接断开，正在重连...', reconnectFailed: '重连失败，请检查 Agent 是否运行',
    items: '项', fields: '个字段', filterField: '筛选字段...', noMatch: '无匹配字段',
    keyNotExist: '(键不存在)', expandAll: '展开全部', collapse: '收起', showMore: '显示更多'
  },
  MarkdownEditor: {
    title: 'Markdown 编辑器', input: '编辑器', preview: '预览',
    phInput: '在此编写 Markdown 内容...', loadSample: '加载示例',
    previewTitle: '实时预览', previewHint: '在上方输入 Markdown 后将在此渲染预览',
    stats: '{chars} 字 {lines} 行', copied: '已复制预览内容',
    toolbar: { bold:'粗体 Ctrl+B',italic:'斜体',strikethrough:'删除线',inlineCode:'行内代码',ul:'无序列表',ol:'有序列表',task:'任务列表',quote:'引用',link:'链接',image:'图片',table:'表格',code:'代码块',hr:'分隔线' },
    tips: { bold:'加粗文字',italic:'倾斜文字',code:'行内代码',link:'超链接',task:'任务列表',quote:'引用块',table:'表格语法' },
    quickRef: '快捷语法参考'
  },
  DnsLookup: {
    title: 'DNS 查询', domain: '域名', type: '记录类型', btnQuery: '查询',
    result: '查询结果', phDomain: '输入域名，如 example.com', noResult: '请输入域名',
    recordCount: '条记录', colIndex: '#', colType: '类型', colValue: '记录值', colTtl: 'TTL',
    emptyHint: '输入域名后点击查询', errNoRecords: '未找到该类型的 DNS 记录', errNetworkError: '网络错误'
  },
  WebsocketTester: {
    title: 'WebSocket 测试', url: '服务地址', btnConnect: '连接', btnDisconnect: '断开',
    message: '消息', btnSend: '发送', log: '消息记录', status: '状态',
    statusConnected: '已连接', statusDisconnected: '未连接', statusConnecting: '连接中...',
    phUrl: 'wss://echo.websocket.org', phMessage: '输入消息，回车发送',
    messageCount: '条消息', emptyHint: '连接 WebSocket 服务后可收发消息',
    errConnect: '连接失败', logConnected: '已连接', logAbnormal: '连接异常', logClosed: '连接已关闭'
  },
  SslChecker: {
    title: 'SSL 证书解析', domain: '域名', btnQuery: '查询',
    result: '证书信息', issuer: '颁发机构', validFrom: '生效时间', validTo: '过期时间',
    daysLeft: '剩余天数', algo: '算法', sanLabel: 'SAN 扩展', phDomain: '输入域名',
    expired: '已过期', expiringSoon: '即将过期', valid: '有效',
    remaining: '剩余', days: '天', to: '至',
    sigAlg: '签名算法', publicKey: '公钥',
    certInfo: '证书信息', domainLabel: '域名', issuerLabel: '颁发机构',
    certType: '证书类型', validity: '有效期', tlsProtocol: 'TLS 协议',
    sanCount: '个域名', certChain: '证书链', chainLevel: '级',
    siteCert: '站点证书', rootCert: '根证书', intermediateCert: '中间证书', issuerBy: '颁发者',
    expiryDate: '到期', emptyHint: '输入域名后点击查询',
    errDomainRequired: '请输入域名', errNetworkError: '网络错误'
  },
  CoordConverter: {
    title: '坐标转换', mode: '模式', single: '单点', batch: '批量',
    from: '源坐标系', to: '目标坐标系', lng: '经度', lat: '纬度',
    btnConvert: '转换', result: '转换结果', phBatch: '经度,纬度（每行一组）'
  },
  RegexTester: {
    title: '正则测试', regexLabel: '正则表达式', testLabel: '测试文本',
    phRegex: '输入正则表达式...', phTest: '输入测试文本...', result: '匹配结果',
    references: '常用正则', matchCount: '{n} 个匹配', noMatch: '无匹配',
    patternHint: '输入正则模式，如 \\d{4}-\\d{2}-\\d{2}',
    flagFull: '全', fullMatch: '完全匹配', matchOk: '✓ 完全匹配', matchFail: '✗ 不匹配',
    totalMatches: '共 {n} 处匹配', itemCount: '项',
    phTestArea: '在此粘贴或输入要测试的文本内容…',
    emptyTitle: '正则表达式测试工具', emptyDesc: '输入正则模式 + 测试文本，实时查看匹配结果',
    emptyStep1: '上方输入正则表达式', emptyStep2: '下方粘贴测试文本', emptyStep3: '查看高亮匹配和结果列表',
    quickRef: '快速体验：',
    refEmail: '邮箱', refPhone: '手机号', refUrl: 'URL', refDate: '日期',
    refIp: 'IP地址', refChinese: '中文', refHexColor: '十六进制颜色', refIdCard: '身份证'
  },
  CronGenerator: {
    title: 'Cron 表达式生成', fields: { minute: '分钟', hour: '小时', day: '日', month: '月', weekday: '星期' },
    every: '每', specific: '指定', range: '范围', step: '步长',
    preview: '预览', expression: '表达式', humanReadable: '说明', nextRuns: '接下来 5 次执行时间',
    presets: '常用预设', presetEveryMinute: '每分钟', presetEveryHour: '每小时', presetEveryDay: '每天零点', presetEveryWeek: '每周一零点',
    builderTitle: '可视化构造器', builderHint: '无需记忆语法，选择即可生成',
    expressionAndDesc: '表达式 & 解读', copyExpression: '复制表达式',
    next5Runs: '近 5 次执行时间', timezone: '时区',
    errNoMatch: '表达式不匹配任何时间，请检查配置', errFixSyntax: '请先修正表达式语法错误',
    sec: '秒', min: '分钟', hour: '小时', day: '日期', month: '月份', week: '星期',
    weekdayNames: { 0:'日',1:'一',2:'二',3:'三',4:'四',5:'五',6:'六' },
    weekHint: '0=日 1=一 … 6=六', weekRangeHint: '（0=日 6=六）',
    from: '从', to: '到', every: '每隔', stepUnit: '步进', start: '从', startStep: '开始，每',
    presetsSec: { everySec:'每秒', every15:'每15秒', every30:'每30秒', specific:'指定' },
    presetsMin: { everyMin:'每分钟', every5:'每5分钟', every10:'每10分钟', every15:'每15分钟', every30:'每30分钟', specific:'指定' },
    presetsHour: { everyHour:'每小时', every2:'每2小时', every6:'每6小时', every12:'每12小时', specific:'指定' },
    presetsDay: { everyDay:'每天', lastDay:'最后一天', specific:'指定', range:'范围' },
    presetsMonth: { everyMonth:'每月', specific:'指定', range:'范围' },
    presetsWeek: { any:'不限', workday:'工作日', weekend:'周末', specific:'指定', range:'范围' },
    tzBeijing: '北京时间 UTC+8', tzTokyo: '东京 UTC+9', tzSingapore: '新加坡 UTC+8',
    tzLondon: '伦敦 UTC+0', tzParis: '巴黎 UTC+1', tzMoscow: '莫斯科 UTC+3',
    tzNewYork: '纽约 UTC-5', tzLosAngeles: '洛杉矶 UTC-8', tzSydney: '悉尼 UTC+11',
    tzDubai: '迪拜 UTC+4', tzMumbai: '孟买 UTC+5:30',
    tzSeoul: '首尔 UTC+9', tzBerlin: '柏林 UTC+1/+2', tzChicago: '芝加哥 UTC-6/-5',
    tzSaoPaulo: '圣保罗 UTC-3', tzAuckland: '奥克兰 UTC+12/+13', tzUTC: 'UTC +0',
    descEverySec: '每秒执行', descEveryMin: '每分钟', descEveryHourMin: '每小时第{min}分',
    descOClock: '点', descMonth: '月', descWeek: '周', descWorkday: '每个工作日', descWeekend: '每个周末',
    descMorning: '上午', descAfternoon: '下午', descEvening: '晚上', descMidnight: '凌晨', descExecute: ' 执行',
    errNeedFields: '至少需要 5 个字段（分 时 日 月 周）', errTooManyFields: '字段过多（最多 7 个：秒 分 时 日 月 周 年）',
    errFieldFormat: '第{n}个字段（{name}）格式错误，范围 {min}-{max}',
    copied: '已复制到剪贴板', copyFailed: '复制失败'
  },
  PhoneList: {
    title: '常用电话', search: '搜索电话...', copy: '点击复制',
    totalRecords: '共 {n} 条记录 · 点击复制', notFound: '未找到匹配的电话号码',
    copied: '已复制 {phone}',
    groups: {
      emergency:{ name:'紧急安全',items:{police:'报警',fire:'火警',ambulance:'急救',traffic:'交通事故',smsPolice:'短信报警',forestFire:'森林火警',seaRescue:'海上救援',redCross:'红十字急救'} },
      life:{ name:'生活服务',items:{dirAssist:'号码查询',weather:'天气预报',time:'报时服务',electric:'电力服务',water:'供水服务',gas:'燃气服务',tv:'有线电视',community:'社区服务'} },
      telecom:{ name:'通讯网络',items:{cmcc:'中国移动',cucc:'中国联通',ct:'中国电信',cbn:'中国广电',phoneFault:'电话故障',netReport:'互联网举报'} },
      bank:{ name:'银行金融',items:{icbc:'工商银行',abc:'农业银行',boc:'中国银行',ccb:'建设银行',bocom:'交通银行',cmb:'招商银行',psbc:'邮储银行',citic:'中信银行',spdb:'浦发银行',unionpay:'银联客服',alipay:'支付宝',wechatPay:'微信支付'} },
      express:{ name:'快递物流',items:{ems:'邮政EMS',sf:'顺丰速运',zto:'中通快递',yto:'圆通速递',sto:'申通快递',yd:'韵达快递',jd:'京东物流',deppon:'德邦快递',jtexpress:'极兔速递',cainiao:'菜鸟物流'} },
      traffic:{ name:'交通出行',items:{railway:'铁路客服',airline:'航空客服',highwayRescue:'高速救援',roadRescue:'道路救援',didi:'滴滴出行'} },
      gov:{ name:'政府服务',items:{govService:'政务服务',consumer:'消费者投诉',quality:'质量监督',tax:'纳税服务',env:'环保举报',discipline:'纪检举报',legalAid:'法律援助',socialSecurity:'社保服务',housingFund:'公积金',health:'卫生服务',culture:'文化举报'} },
      insurance:{ name:'保险',items:{picc:'中国人保',chinalife:'中国人寿',pingan:'中国平安',cpic:'太平洋保险',taiping:'太平保险'} },
      ecommerce:{ name:'电商互联网',items:{taobao:'淘宝/天猫',jdcom:'京东',pinduoduo:'拼多多',douyin:'抖音',meituan:'美团',eleme:'饿了么',ctrip:'携程'} },
      airline:{ name:'航空',items:{airchina:'国航',eastern:'东航',southern:'南航',hainan:'海航',xiamen:'厦航',sichuan:'川航',shenzhen:'深航',spring:'春秋航空'} }
    }
  },
  LocationQuery: {
    title: '归属地查询', phone: '手机号', ip: 'IP 地址', idcard: '身份证',
    ipTitle: 'IP 归属地查询', idcardTitle: '身份证归属地查询', phoneTitle: '手机号归属地查询',
    phPhone: '输入手机号（前3位或前7位）', phIp: '输入 IP 地址...', phIdcard: '输入 18 位身份证号',
    btnQuery: '查询', result: '查询结果',
    country: '国家', province: '省份', city: '城市', isp: '运营商', carrier: '运营商',
    ipHint: '输入 IP 后按回车或点查询',
    district: '省 / 市 / 区', birth: '出生日期', gender: '性别', age: '年龄',
    male: '👨 男', female: '👩 女',
    needMoreDigits: '还需输入 {n} 位', invalidIdcard: '请输入正确的身份证号码',
    phoneHint: '输入 3 位识别运营商，7 位查询归属地',
    queryFailed: '查询失败', checkNetwork: '请检查网络',
    unknown: '未知', notRecorded: '未收录'
  },
  CharCount: {
    title: '字数统计', hint: '实时统计', chars: '字符', words: '单词', lines: '行', bytes: '字节',
    sentences: '句子', paragraphs: '段落', chineseChars: '中文字数',
    totalChars: '总字符数', charsNoSpace: '字符数(无空格)', bytesUTF8: '字节数(UTF-8)',
    phInput: '输入或粘贴文本...', wordCount: '单词数', lineCount: '行数',
    cnCharCount: '中文字数', sentenceCount: '句子数', paragraphCount: '段落数'
  },
  // ----- 计算器类 -----
  MortgageCalculator: {
    title: '房贷计算器', commercial: '商业贷款', fund: '公积金贷款',
    amount: '贷款金额（万元）', years: '贷款年限', rate: '年利率（%）',
    method: '还款方式', methodEI: '等额本息', methodEP: '等额本金',
    monthly: '每月还款（元）', total: '还款总额（元）', interest: '总利息（元）',
    yearLabel: '{y} 年（{n} 期）', commercialLoan: '商业贷', fundLoan: '公积金贷',
    perMonth: '元/月', principalNote: '* 等额本金每月还款额递减，上方为「首月 ~ 末月」范围',
    detailTitle: '逐期还款明细（共 {n} 期）',
    colPeriod: '期数', colPayment: '月供', colPrincipal: '本金', colInterest: '利息', colBalance: '剩余本金',
    emptyHint: '填写贷款参数后自动计算', phAmount: '如 70', phRate: '如 3.25'
  },
  TaxCalculator: {
    title: '个税计算器', type: '所得类型', typeSalary: '工资薪金', typeBonus: '年终奖', typeLabor: '劳务报酬',
    salary: '税前月收入（元）', socialInsurance: '社保+公积金（元/月）', deduction: '专项附加扣除（元/月）',
    threshold: '起征点（元/月）',
    bonus: '年终奖总额（元）', bonusSalaryLabel: '当月工资是否达起征点',
    yes: '是', no: '否',
    mergeIncome: '并入综合所得',
    labor: '劳务收入（元）', result: '应纳税额（元）', taxable: '应纳税所得额（元）',
    afterTax: '税后收入（元）',
    phSalary: '如 20000', phSocial: '如 4000', phDeduction: '子女教育/房贷利息/租房等，如 3000',
    phThreshold: '5000', phBonus: '如 100000', phLabor: '如 50000',
    rateRefTitle: '个税税率表参考',
    colLevel: '级数', colTaxableRange: '应纳税所得额（月）', colRate: '税率', colQuickDeduction: '速算扣除数',
    emptyHint: '填写收入信息后自动计算',
    taxFree: '应纳税所得额 ≤ 0，无需缴纳个税',
    rateInfo: '适用税率 {rate}%，速算扣除数 {quick}',
    bonusInfo: '年终奖 ÷ 12 = {avg} → 税率 {rate}%，速算扣除 {quick}',
    laborFree: '劳务报酬 ≤ 800 元，免征个税',
    laborLow: '减除 800 元费用后按 20% 计征',
    laborMid20: '减除 20% 费用后按 20% 计征',
    laborMid30: '减除 20% 费用后按 30% 加成，速算扣除 2000',
    laborMid40: '减除 20% 费用后按 40% 加成，速算扣除 7000',
    copyTax: '应纳税额: {tax} 元\n税后收入: {afterTax} 元',
    bracketUpTo: '不超过 {n}', bracketRange: '{from} ~ {to}', bracketOver: '超过 {n}'
  },
  BmiCalculator: {
    title: 'BMI 计算器', height: '身高', weight: '体重',
    result: 'BMI 值', category: '分类', idealWeight: '理想体重 {min} ~ {max} kg',
    underweight: '偏瘦', normal: '正常', overweight: '偏胖', obese: '肥胖',
    hint: '输入身高和体重，自动计算 BMI 指数'
  },
  BabyHeight: {
    title: '宝宝身高预测', father: '父亲身高 (cm)', mother: '母亲身高 (cm)',
    boy: '男孩预测身高', girl: '女孩预测身高', formula: '遗传身高公式',
    boyShort: '男孩', girlShort: '女孩', fatherShort: '父亲', motherShort: '母亲',
    compare: '身高对比',
    formulaHint: '公式: 男孩=(父+母+13)/2，女孩=(父+母-13)/2。±5cm 参考范围，实际受营养运动睡眠影响',
    hint: '输入父母身高（厘米），预测宝宝成年身高'
  },
  CompoundInterest: {
    title: '存款利息计算器', principal: '本金（元）', rate: '年利率（%）',
    years: '期限（年）', frequency: '复利频率', yearly: '每年', monthly: '每月', daily: '每日',
    total: '本息合计', totalInterest: '总利息', chart: '逐年增长',
    unitYuan: '元', effRate: '实际年化', chartTitle: '逐年本息增长',
    legendPrincipal: '本金', legendInterest: '利息',
    yearLabel: '{y}年', detailTitle: '逐年明细（共 {n} 年）',
    colYear: '年份', colStart: '年初本金', colInterest: '当年利息', colEnd: '年末本息',
    emptyHint: '填写存款参数，自动计算复利本息',
    phPrincipal: '如 100000', phRate: '如 3.5'
  },
  BloodType: {
    title: '血型遗传速查', father: '父亲血型', mother: '母亲血型',
    result: '子女可能血型', probability: '概率', table: '血型遗传对照表',
    type: '型', selectHint: '选择父母血型查看子女可能血型',
    parentTypes: '父母血型'
  },
  // ----- 流程图/图表 -----
  Flowchart: {
    title: '流程图制作', shapes: '图形', tools: '工具', exportPng: '导出 PNG', exportSvg: '导出 SVG',
    clear: '清空', sample: '加载示例', undo: '撤销', redo: '重做',
    autoLayout: '自动布局', delete: '删除选中', selectAll: '全选'
  },
  Mindmap: {
    title: '思维导图', input: '大纲输入', phInput: '每行一个节点，Tab 缩进表示层级...',
    hint: '```\n中心主题\n\t子节点1\n\t\t子节点1.1\n\t子节点2\n```'
  },
  SequenceDiagram: {
    title: 'UML 时序图', addObject: '添加对象', addActor: '添加角色',
    addFragment: '组合片段', fragmentAlt: 'alt (条件分支)', fragmentOpt: 'opt (可选)',
    fragmentLoop: 'loop (循环)', fragmentPar: 'par (并行)', fragmentBreak: 'break (中断)',
    editLabel: '双击编辑文字', hint: '点击第一个对象选中，再点击第二个对象连线'
  },
  ChartMaker: {
    title: '数据图表制作', subtitle: '输入数据即时生成',
    typeLabel: '图表类型', typeBar: '柱状图', typeLine: '折线图',
    typePie: '饼图', typeHBar: '横向柱状图', titleLabel: '图表标题',
    dataLabel: '标签', dataValue: '数值', addRow: '添加行', download: '下载 PNG',
    phLabel: '标签', phValue: '数值', phTitle: '图表标题（可选）',
    stats: '{n} 条数据 · 合计 {total}',
    sampleTitle: '2025上半年销售额',
    sampleMonths: ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
    colLabel: '标签', colValue: '数值'
  },
  GeometryDraw: {
    title: '数学图形绘制', modePoint: '点', modeLine: '线', modeCircle: '圆',
    modeTriangle: '三角形', modeQuad: '四边形', modeFunc: '函数图像',
    btnExportPng: '导出PNG', btnExportSvg: '导出SVG', btnClear: '清空',
    templates: '快捷模板', undo: '撤销', redo: '重做', grid: '网格'
  },
  // ----- 功能类 -----
  FunctionPlot: {
    title: '函数绘图', input: '函数表达式', phInput: '如: sin(x), x^2-4*x+3',
    btnPlot: '绘制', xRange: 'X 范围', yRange: 'Y 范围',
    basic: '基础', trig: '三角', exp: '指数',
    autoFit: '自动适配', lockY: '锁定Y轴',
    tangent: '切线', integral: '积分', clear: '清除',
    showKeyPoints: '显示关键点',
    hide: '隐藏', show: '显示',
    exportPng: '导出 PNG', exportSvg: '导出 SVG',
    cursorHint: '滚轮缩放 | Shift+拖拽平移 | 双击标切线',
    errSyntax: '公式语法错误'
  },
  ChineseConverter: {
    title: '中文繁简体转换', input: '输入', output: '结果',
    direction: '方向', toTraditional: '简 → 繁', toSimplified: '繁 → 简',
    phInput: '粘贴文字...', phStoT: '输入简体中文...', phTtoS: '輸入繁體中文...',
    phOutput: '转换结果...'
  },
  PinyinConverter: {
    title: '文本转拼音', input: '输入中文文本，自动转换为拼音', output: '转换结果',
    mode: '输出格式', modeTone: '带声调', modeNumber: '数字调', modeNone: '无声调',
    phInput: '输入中文文本，如：重庆是一座美丽的山城', phOutput: '拼音结果...',
    tokens: '逐字对照', multiChar: '多音字', identified: '已识别',
    charsCount: '{n} 个字符', multiCount: '{n} 个多音字',
    emptyHint: '输入中文文本后自动转换', copied: '已复制拼音'
  },
  AsciiArt: {
    title: 'ASCII 艺术生成器', mode: '模式', imgToAscii: '图片转 ASCII', textToAscii: '文字转 ASCII',
    upload: '上传图片', uploadHint: 'PNG / JPG / WebP', width: '输出宽度',
    dropText: '将图片拖到此处或', clickUpload: '点击上传',
    charset: '字符集', charsetStandard: '标准', charsetSimple: '精简', charsetCustom: '自定义',
    font: '字体风格', copy: '复制', phText: '输入文字...',
    outputPreview: '输出预览', metaChars: '{w} x {h} 字符',
    emptyImage: '上传图片后自动生成 ASCII 字符画', emptyText: '输入文字后自动生成 ASCII 字符画',
    copied: '已复制 ASCII 字符画',
    useCases: '使用场景: 代码注释 · 终端欢迎界面 · README 装饰'
  },
  BarcodeGenerator: {
    title: '条形码生成器', input: '条形码内容', format: '条码格式',
    formatCode128: 'CODE128', formatEAN: 'EAN-13', formatUPC: 'UPC-A',
    formatCode39: 'CODE39', formatITF: 'ITF',
    download: '下载 PNG', random: '随机',
    hint: '选择条码类型，输入内容即可生成',
    hintCode128: '通用 | 数字+大小写字母+符号，物流/仓储/快递面单',
    hintEAN: '商品零售 | 13位纯数字，前3位国家码(中国690-699)，末位校验码自动计算',
    hintUPC: '美加零售 | 12位纯数字，末尾校验码自动计算',
    hintCode39: '工业制造 | 数字+大写字母+7个符号，汽车/国防/医疗',
    hintITF: '物流外箱 | 14位纯数字，瓦楞纸箱批量运输标签',
    valid: '格式正确',
    errEAN: '至少 12 位数字，输入 12 位自动补齐校验位',
    errUPC: '至少 11 位数字，输入 11 位自动补齐校验位',
    errITF: '需要 14 位纯数字',
    errCode39: '仅支持数字、大写字母、- . $ / + % 空格',
    errCode128: '仅支持可打印 ASCII 字符',
    errDigitOnly: '仅支持纯数字',
    errTooLong: '输入内容过长'
  },
  BarcodeDecoder: {
    title: '条形码解码', dropHint: '拖拽或点击上传条形码图片', tip: '支持 EAN/UPC/CODE128/CODE39/ITF/CODABAR 等一维条码格式',
    btnDecode: '开始解码', decoding: '正在识别...', found: '识别成功',
    content: '解码内容', format: '条码格式', position: '定位坐标',
    redecode: '重新解码', retry: '重试', notFound: '未识别到条形码，请检查图片清晰度',
    decodeFail: '解码失败', notSupported: '当前浏览器不支持 BarcodeDetector API，请使用 Chrome 88+ 或 Edge 88+'
  },
  MbtiTest: {
    title: 'MBTI 人格测试', subtitle: '根据真实想法选择，没有对错之分', question: '第 {n} / {total} 题', prev: '上一题', next: '下一题',
    viewResult: '查看我的性格类型',
    result: '测试结果', typeLabel: '你的类型', description: '类型描述',
    career: '适合职业', restart: '重新测试',
    dimE: '外向 (E)', dimI: '内向 (I)', dimS: '实感 (S)', dimN: '直觉 (N)',
    dimT: '理性 (T)', dimF: '感性 (F)', dimJ: '计划 (J)', dimP: '随性 (P)',
    types: {
      ISTJ:{name:'检查员',desc:'务实严谨，注重细节，遵守规则。善于组织和规划，是可靠的执行者。适合会计、审计、公务员等职业。'},
      ISFJ:{name:'守护者',desc:'温暖周到，忠诚可靠，默默付出。善于照顾他人需求，是团队的守护者。适合医护、教育、社会工作等职业。'},
      INFJ:{name:'提倡者',desc:'理想主义，富有洞察力，追求意义。善于理解深层动机，是安静的变革推动者。适合心理咨询、写作、人力资源等职业。'},
      INTJ:{name:'建筑师',desc:'战略思维，独立思考，追求卓越。善于系统规划和长远布局。适合科研、工程、战略咨询等职业。'},
      ISTP:{name:'鉴赏家',desc:'冷静务实，动手能力强，喜欢探索原理。善于解决实际技术问题。适合工程、技术维修、数据分析等职业。'},
      ISFP:{name:'探险家',desc:'温和友善，审美敏锐，活在当下。善于发现和创造美好事物。适合设计、艺术、手工艺等职业。'},
      INFP:{name:'调停者',desc:'内心丰富，富有同理心，追求价值一致。善于理解他人情感和创意表达。适合写作、艺术、心理咨询等职业。'},
      INTP:{name:'逻辑学家',desc:'理性分析，充满好奇，追求真理。善于逻辑推理和创新思考。适合理工研究、编程、哲学等职业。'},
      ESTP:{name:'企业家',desc:'精力充沛，行动力强，喜欢冒险挑战。善于抓住机会快速决策。适合销售、创业、运动等职业。'},
      ESFP:{name:'表演者',desc:'热情开朗，善于交际，享受当下快乐。有感染力，是人群中的焦点。适合演艺、公关、旅游等职业。'},
      ENFP:{name:'竞选者',desc:'热情创意，充满想象，善解人意。有强烈的好奇心和感染力。适合创意、教育、传媒等职业。'},
      ENTP:{name:'辩论家',desc:'思维敏捷，善于辩论，喜欢突破常规。善于发现新的可能性和机会。适合创业、法律、咨询等职业。'},
      ESTJ:{name:'总经理',desc:'组织能力强，果断务实，注重效率。善于管理和执行。适合管理、行政、军事等职业。'},
      ESFJ:{name:'执政官',desc:'热心负责，善于协作，注重和谐。是优秀的组织者和支持者。适合教育、行政、服务业等职业。'},
      ENFJ:{name:'主人公',desc:'富有魅力，关心他人成长，善于激励。是天生的领导者和教育者。适合教育、培训、公益等职业。'},
      ENTJ:{name:'指挥官',desc:'果断自信，善于领导，追求成就。是强大的战略家和执行者。适合管理、创业、金融等职业。'}
    },
    questions: [
      {text:'在社交场合中，你通常会',a:'主动结识新朋友，感到精力充沛',b:'更喜欢与熟悉的人相处，长时间社交会感到疲惫'},
      {text:'做决定时，你更倾向于',a:'理性分析利弊，依据客观事实和逻辑',b:'考虑他人感受和价值观，追求和谐与共识'},
      {text:'在日常生活中，你更注重',a:'具体细节和实际经验，关注当下',b:'抽象概念和未来可能，关注大局'},
      {text:'你的生活和工作方式更偏向',a:'有计划、有条理，喜欢提前安排和确定',b:'灵活开放，喜欢保留选择和随机应变'},
      {text:'阅读或学习时，你更喜欢',a:'注重事实、数据和具体案例',b:'注重理论框架和概念系统'},
      {text:'与人相处时，你更倾向于',a:'坦诚直言，对事不对人，能够客观批评',b:'委婉表达，照顾对方情绪，避免冲突'},
      {text:'周末你更喜欢',a:'参加聚会、运动或外出活动',b:'在家阅读、看电影或做个人项目'},
      {text:'解决问题时，你通常',a:'先行动再调整，在实践中摸索方案',b:'先思考再行动，在脑中推演可能性'},
      {text:'在工作中，你更在意',a:'明确的目标、清晰的流程和可见的成果',b:'工作的意义、个人成长和团队氛围'},
      {text:'面对新任务时，你更倾向于',a:'从已有的经验和已知的方法入手',b:'尝试全新的思路和方法，即使有风险'},
      {text:'在团队中，你通常是',a:'主动发言，积极分享想法，带动讨论',b:'先倾听再表达，深思熟虑后才发言'},
      {text:'你的桌面或房间通常是',a:'物品摆放整齐有序，喜欢整洁',b:'随性自然，只要知道东西在哪就行'}
    ]
  },
  ExpressTracking: {
    title: '快递单号查询', input: '快递单号', btnQuery: '查询',
    hintAuto: '自动识别快递公司并跳转到官方查询页面', phInput: '输入快递单号...',
    courier: '快递公司', trackingNo: '快递单号', goOfficial: '前往官方查询',
    requery: '重新查询', courierList: '支持 {n} 家快递公司 · 点击示例快速体验',
    emptyInput: '请输入快递单号', notRecognized: '未能识别该快递单号，请检查单号是否正确'
  },
  WatermarkRemove: {
    title: '快速去水印', upload: '上传图片', uploadHint: 'PNG / JPEG / WebP · 20MB',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    lassoMode: '圈选模式', lasso: '套索圈选', brushMode: '画笔涂抹', brushSize: '笔刷大小',
    clear: '清除', undoVertex: '回退顶点', dblClickClose: '双击闭合',
    btnRemove: '开始去水印', processing: '处理中...', loadEngine: '加载引擎...',
    original: '原图', result: '去水印结果', download: '下载结果',
    reupload: '重新上传', maxSize: '最大20MB', noFile: '请先上传图片',
    noMask: '未标记水印区域', imgParseFail: '图片解析失败',
    cvLoadFail: 'OpenCV引擎加载失败', cvTimeout: 'OpenCV引擎加载超时',
    imgLoadFail: '图片加载失败，请重试', done: '处理完成'
  },
  WordToPdf: {
    title: 'Word 转 PDF', upload: '上传 Word 文档', uploadHint: '.docx / .doc · Max 50MB',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnConvert: '转换为 PDF', processing: '正在转换，请稍候...',
    generated: 'PDF 已生成', download: '下载 PDF', reupload: '重新转换',
    maxSize: '最大50M', convertFail: '转换失败', note: '注意：服务器需安装 Microsoft Office'
  },
  PdfToWord: {
    title: 'PDF 转 Word', upload: '上传 PDF 文件', uploadHint: 'Max 50MB',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnConvert: '转换为 Word', processing: '正在转换，请稍候...',
    generated: 'Word 已生成', download: '下载 .docx', reupload: '重新转换',
    maxSize: '最大20M', convertFail: '转换失败'
  },
  PptToWord: {
    title: 'PPT 转 Word', upload: '上传 PPT 文件', uploadHint: '.ppt / .pptx · 50MB',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnConvert: '转换为 Word', processing: '正在转换 PPT，请稍候...',
    generated: 'Word 文档已生成', download: '下载 Word', reupload: '重新转换',
    maxSize: '文件不能超过50MB', convertFail: '转换失败', note: '仅提取文字内容'
  },
  ExcelToWord: {
    title: 'Excel 转 Word', upload: '上传 Excel 文件', uploadHint: '.xls / .xlsx · 50MB',
    dropText: '将文件拖到此处，或', clickUpload: '点击上传',
    btnConvert: '转换为 Word', processing: '正在转换 Excel，请稍候...',
    generated: 'Word 文档已生成', download: '下载 Word', reupload: '重新转换',
    maxSize: '文件不能超过50MB', convertFail: '转换失败'
  },
  PdfSplit: {
    title: 'PDF 拆分', upload: '上传 PDF 文件', uploadHint: '支持 .pdf 格式，Max 50MB',
    dropText: '拖拽 PDF 文件到此处，或点击上传', clickUpload: '点击上传',
    selectFile: '选择文件', pageRange: '页码范围', phRange: '例: 1-3,5,7-10',
    btnSplit: '开始拆分', splitting: '拆分中...', download: '下载', reupload: '重新上传',
    maxSize: '最大50M', hintPageRange: '支持逗号分隔，如：1,3,5-8',
    errNeedPdf: '请选择 PDF 文件', errNeedPages: '请输入页码范围', errSplit: '拆分失败',
    clickUploadText: '点击上传'
  },
  TimezoneConverter: {
    title: '时区转换', worldClock: '世界时钟', converter: '时区转换',
    fromTz: '源时区', toTz: '目标时区', time: '日期时间', btnNow: '当前时间',
    result: '转换结果', dateTimeLabel: '日期时间', dateTimePlaceholder: '选择日期时间'
  },
  TableStructure: {
    title: 'MySQL 表结构文档', host: '主机地址', port: '端口', user: '用户名',
    password: '密码', database: '数据库名', btnExport: '导出 Word 文档',
    passwordPlaceholder: '留空表示无密码',
    hostRequired: '请输入主机地址', userRequired: '请输入用户名', databaseRequired: '请输入数据库名',
    note: '生成文档包含：表名、表注释、字段序号、字段名、字段类型、是否必填、字段备注',
    tipUsage: '输入 MySQL 数据库连接信息，点击导出即可下载包含所有表结构的设计文档（Word 格式）',
    tipSecurity: '仅用于内网环境，请勿在公网传输数据库密码',
    exportSuccess: '导出成功', exportFail: '导出失败，请检查连接信息',
    directMode: '直连模式', agentMode: 'Agent 模式',
    sessionId: '会话ID', phSessionId: '输入 Agent 显示的会话ID',
    sessionIdRequired: '请输入会话ID',
    downloadAgent: '下载 Agent', agentHelp: '无法连接内网数据库？下载 Agent 即可桥接访问',
    errAgentConnect: '无法连接 Agent，请确认会话ID正确且 Agent 已启动',
    agentDisconnected: 'Agent 已断开连接'
  },
  SwaggerDoc: {
    title: 'Swagger 接口文档', version: 'Swagger 版本', version2: '2.x (/v2/api-docs)', version3: '3.0 (/v3/api-docs)',
    url: '接口文档地址', phUrl: 'https://example.com/v2/api-docs',
    btnGenerate: '生成文档', note: '自动解析接口参数、响应码、数据结构，生成 Word 文档',
    urlRequired: '请输入地址', tipUsage: '输入 Swagger/OpenAPI 接口文档 JSON 地址，选择对应版本即可生成 Word 格式的接口文档',
    tipExample2: 'Swagger 2.x 地址示例', tipExample3: 'OpenAPI 3.0 地址示例',
    generateSuccess: '生成成功', generateFail: '生成失败，请检查地址和版本',
    directMode: '直连模式', agentMode: 'Agent 模式',
    sessionId: '会话ID', phSessionId: '输入 Agent 显示的会话ID',
    sessionIdRequired: '请输入会话ID',
    downloadAgent: '下载 Agent', agentHelp: 'Swagger 地址在内网无法访问？下载 Agent 即可代理抓取',
    errAgentConnect: '无法连接 Agent，请确认会话ID正确且 Agent 已启动',
    agentDisconnected: 'Agent 已断开连接'
  }
}
